import React, { useEffect, useState } from 'react';
import { Alert, Box, Collapse, IconButton, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { MdiIcon, Table, useSnackbar } from '@components';
import { mdiChevronUp, mdiContentSave, mdiMagnify, mdiPlus } from '@mdi/js';
import Grid2 from '@mui/material/Unstable_Grid2';
import Grid from '@mui/system/Unstable_Grid';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
const PessoasAssociadasEmpresa = ({ $state, CrmService, client, load }) => {
    // Tabela
    const loadParams = () => {
        const sortBy = $state.params.sortBy;
        if (sortBy == undefined) {
            return [];
        }
        const o = [];
        sortBy.forEach(r => {
            const s = r.split(':');
            o.push({ id: s[0], desc: s[1] == 'DESC' });
        });
        return o;
    };
    const [data, setData] = useState(); // dados dos Contactos
    const [loading, setLoading] = useState(true);
    const [refetching, setRefetching] = useState(false);
    const [error, setError] = useState(false);
    const [filter, setFilter] = useState([]); // filtros a aplicar na tabela
    // exemplo -> [{ id: 'nome', value: 'Pedro', type: 'contains' }, { id: 'email', value: 'gmail', type: 'contains' }]
    const [sort, setSort] = useState(() => loadParams()); // ordenação da tabela
    // exemplo -> [{id: 'ultimoContacto', desc: false}]
    const [options, setOptions] = useState({
        filter: [], // exemplo -> [{name: 'nome', type: 'TEXT'}, {name: 'ultimoContacto', type: 'DATE', options: {format: 'YYYY-MM-DD'}}, ...]
        sort: [] // exemplo -> ['id', 'nome', 'ultimoContacto', 'contactoTelefonico', 'nif', 'email', 'morada', 'localidade']
    });
    const [pagination, setPagination] = useState({
        pageIndex: $state.params.page - 1 || 0,
        pageSize: $state.params.limit || 10
    });
    const [expand, setExpand] = useState(false);
    const { showSnackbar } = useSnackbar();
    function stringToColor(string) {
        let hash = 0;
        let i;
        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }
        let color = '#';
        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */
        return color;
    }
    function stringAvatar(name) {
        // Verifica se o nome é válido e tem pelo menos uma palavra
        const nameParts = name.split(' ');
        const firstInitial = nameParts[0] ? nameParts[0][0] : '';
        const secondInitial = nameParts[1] ? nameParts[1][0] : '';
        return {
            sx: {
                bgcolor: stringToColor(name)
            },
            children: `${firstInitial}${secondInitial}`
        };
    }
    // Filtragem dentro de cada coluna
    // Modo de filtro (igual a, contém, começa com... )
    const getType = (type) => {
        switch (type) {
            case 'contains':
                return '$ilike';
            case 'startsWith':
                return '$sw';
            case 'notEquals':
                return '$not';
            case 'empty':
                return '$null';
            case 'notEmpty':
                return '$notNull';
            case 'greaterThan':
                return '$gt';
            case 'greaterThanOrEqualTo':
                return '$gte';
            case 'lessThan':
                return '$lt';
            case 'lessThanOrEqualTo':
                return '$lte';
            default:
                return '$eq';
        }
    };
    // ir para detalhes da pessoa (envia id da empresa)
    const onCellView = (cell) => {
        $state.go('app.crm.pessoas.details', { id: cell.id });
    };
    const formik = useFormik({
        initialValues: {
            dataCriacao: moment()
        },
        validationSchema: yup.object({
            nome: yup.string().required('O campo é obrigatório'),
            email: yup
                .string()
                .required('O campo é obrigatório')
                .email('Introduza um email válido')
                .test('exists', 'O email introduzido já se encontra registado', async (value) => {
                if (!value) {
                    return true;
                }
                const d = await CrmService.existsInContacto('email', value);
                return d.count === 0;
            }),
            contactoTelefonico: yup.string().notRequired(),
            dataCriacao: yup
                .string()
                .required('O campo é obrigatório')
                .test('is-date', 'Introduza uma data válida', value => moment(value).isValid()),
            nif: yup
                .string()
                .notRequired()
                .test('is-nif', 'Introduza um NIF válido', value => {
                if (!value || value.trim() === '') {
                    return true;
                }
                return CrmService.isValidNIF(value);
            })
                .test('exists', 'O NIF introduzido já se encontra registado', async (value) => {
                if (!value || value.trim() === '') {
                    return true;
                }
                const d = await CrmService.existsInContacto('nif', value);
                return d.count === 0;
            })
        }),
        validateOnMount: false,
        onSubmit: async (values) => {
            try {
                const d = await CrmService.createContato({ dataEntrada: moment(values.dataCriacao).format(), clienteId: client, contactoTelefonico: values.contactoTelefonico, nome: values.nome, nif: values.nif, email: values.email });
                setExpand(false);
                formik.resetForm();
                showSnackbar('Contacto registado com sucesso');
            }
            catch (e) {
                console.log(e);
                showSnackbar('Ocorreu um erro ao registar contacto');
            }
            fetchData();
        }
    });
    const initialFetch = async () => {
        if (loading) {
            // opt -> vai buscar os campos filtraveis
            const opt = await CrmService.optionsContactos();
            setOptions(opt);
            setLoading(false);
        }
    };
    const fetchData = async () => {
        setError(false);
        try {
            let filters = {};
            filter.forEach(r => {
                filters[r.id] = `${getType(r.type)}:${r.value}`;
            });
            let sorter = [];
            sort.forEach(r => {
                sorter.push(`${r.id}:${r.desc ? 'DESC' : 'ASC'}`);
            });
            const aux = await CrmService.findAllContactos({
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                filter: filters,
                sortBy: sorter
            }, client);
            $state.go($state.current.name, {
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                sortBy: sorter,
                filter: Object.keys(filter).length > 0 ? JSON.stringify(filters) : undefined
            }, {
                notify: false,
                reload: false,
                location: 'replace',
                inherit: true
            });
            // Update URL
            setData(aux);
        }
        catch (e) {
            console.log(e);
            setError(true);
        }
        setRefetching(false);
    };
    // atualizações da tabela
    useEffect(() => {
        initialFetch();
        if (!refetching) {
            setRefetching(true);
            fetchData();
        }
    }, [pagination, filter, sort]);
    useEffect(() => {
        if (load) {
            fetchData();
        }
    }, [load]);
    return (<Box sx={{ mt: 2 }}>
      <Stack direction='column'>
        <Stack direction='row' spacing={1} justifyContent='flex-start' alignItems='center'>
          <Typography variant='h6' sx={{ color: 'black' }}>
            Contactos
          </Typography>
          {expand ? (<Box>
              <Tooltip title={'Cancelar'}>
                <IconButton color='primary' onClick={() => {
                setExpand(!expand);
                formik.resetForm();
            }}>
                  <MdiIcon path={mdiChevronUp} sx={{ color: '#1976D2' }}/>
                </IconButton>
              </Tooltip>
              <Tooltip title={'Associar contacto'}>
                <span>
                  <IconButton disabled={!(formik.dirty && formik.isValid)} color='primary' onClick={() => {
                formik.handleSubmit();
            }}>
                    <MdiIcon path={mdiContentSave} sx={{ color: formik.dirty && formik.isValid ? '#1976D2' : '#E0E0E0' }}/>
                  </IconButton>
                </span>
              </Tooltip>
            </Box>) : (<Tooltip title={'Adicionar contacto'}>
              <IconButton color='primary' onClick={() => {
                setExpand(!expand);
            }}>
                <MdiIcon path={mdiPlus} sx={{ color: '#1976D2' }}/>
              </IconButton>
            </Tooltip>)}
        </Stack>

        <Collapse in={expand} sx={{ mb: 1 }}>
          <Grid2 container spacing={2} sx={{ mt: 1 }}>
            <Grid xs={12}>
              <Alert color='info'>Para adicionar um contacto existente à empresa, deverá efetuar a associação pelo contacto.</Alert>
            </Grid>

            <Grid lg={12} md={12} xs={12}>
              <TextField label='Nome' type='text' name='nome' size='small' required value={formik.values?.nome} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.nome && Boolean(formik.errors.nome)} helperText={formik.touched.nome && formik.errors.nome}/>
            </Grid>
            <Grid lg={6} md={12} xs={12}>
              <TextField label='NIF' type='text' name='nif' size='small' value={formik.values?.nif} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.nif && Boolean(formik.errors.nif)} helperText={formik.touched.nif && formik.errors.nif}/>
            </Grid>
            <Grid lg={6} md={12} xs={12}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker slotProps={{
            textField: {
                size: 'small',
                fullWidth: true,
                label: 'Data de entrada',
                required: true,
                helperText: formik.touched.dataCriacao && String(formik.errors.dataCriacao),
                error: formik.touched.dataCriacao && Boolean(formik.errors.dataCriacao),
                onBlur: formik.handleBlur
            }
        }} name='dataCriacao' value={formik.values?.dataCriacao} onChange={val => {
            formik.setFieldValue('dataCriacao', val, true);
        }}/>
              </LocalizationProvider>
            </Grid>
            <Grid lg={6} md={6} xs={6}>
              <TextField label='Email' type='email' name='email' size='small' required value={formik.values?.email} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.email && Boolean(formik.errors.email)} helperText={formik.touched.email && formik.errors.email}/>
            </Grid>
            <Grid lg={6} md={6} xs={6}>
              <TextField label='Contacto Telefónico' type='number' name='contactoTelefonico' size='small' value={formik.values?.contactoTelefonico} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.contactoTelefonico && Boolean(formik.errors.contactoTelefonico)} helperText={formik.touched.contactoTelefonico && formik.errors.contactoTelefonico}/>
            </Grid>
          </Grid2>
        </Collapse>

        <Box sx={{
            borderRadius: '15px', // Aplica o arredondamento na parte externa
            border: '1px solid #e0e0e0', // Adiciona uma borda leve
            overflow: 'hidden', // Garante que o conteúdo não extrapole o arredondamento
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)' // Adiciona uma leve sombra
        }}>
          <Table onDoubleClick={row => {
            onCellView(row);
        }} storageKey={$state.current.name} data={data} columns={[
            {
                accessorKey: 'nome',
                header: 'Nome',
                size: 150
            },
            {
                accessorKey: 'email',
                header: 'Email',
                size: 150
            },
            {
                accessorKey: 'contactoTelefonico',
                header: 'Contacto',
                size: 90
            }
        ]} initial={{
            sort: sort,
            filter: filter
        }} isLoading={refetching} options={options} onPaginate={setPagination} onFilter={setFilter} onSort={setSort} rowActionSize={100} actionItems={({ row }) => [
            <Box key={`actions-${row.original.id}`} gap={1} sx={{
                    width: '100%', // Ocupa toda a largura da célula
                    height: '100%', // Ocupa toda a altura da célula
                    display: 'flex',
                    justifyContent: 'center', // Centra horizontalmente
                    alignItems: 'center' // Centra verticalmente
                }}>
                <Tooltip title={'Ver detalhes'} placement='top'>
                  <IconButton color='secondary' onClick={() => {
                    window.open($state.href('app.crm.pessoas.details', { id: row.original.id }, { absolute: true }));
                }}>
                    <MdiIcon path={mdiMagnify} sx={{ color: '#1976D2' }}/>
                  </IconButton>
                </Tooltip>
                {/* <Tooltip title={'Remover associação'} placement='top'>
                  <IconButton
                    color='secondary'
                    onClick={() => {
                      saveAssociation(row.original.id, 1);
                    }}>
                    <MdiIcon path={mdiTrashCan} sx={{ color: '#D32F2F' }} />
                  </IconButton>
                </Tooltip> */}
              </Box>
        ]}></Table>
        </Box>
      </Stack>
    </Box>);
};
export default PessoasAssociadasEmpresa;
